<template>
  <section id="kontakt">
    <div id="kontakt-anchor" class="scroll-to-anchor"></div>

    <div class="container">
      <div class="row">
        <div class="col-md-8">
          <h2>Betonarna sava d.o.o.</h2>

          <div class="small">
            Blejska Dobrava 123B, Blejska Dobrava, 4273 Blejska Dobrava
            <br /><br />
            <strong>Obrat Hrušica, 4276 Hrušica</strong>
            <strong>Tel.: 080 50 60 | E-mail: info@betonarna-sava.si</strong>
          </div>

          <div class="delovni">
            <strong>Delovni čas obrata:</strong>
            <div class="working-hours">
              <div class="days">
                PON - PET <br />
                SOBOTA
              </div>
              <div class="hours">
                7:00 - 17:00<br />
                7:00 - 13:00
              </div>
            </div>
          </div>

          <div class="delovni">
            <strong>Delovni čas betonarne:</strong>
            <div class="working-hours">
              <div class="days">
                PON - PET <br />
                SOBOTA
              </div>
              <div class="hours">
                7:00 - 16:00<br />
                7:00 - 12:00
              </div>
            </div>
          </div>

          <div class="extra-info visible-sm">
            <strong>VODSTVO</strong>
            Matej Oblak<br />
            041 633 775<br />
            <a href="mailto:matej@betonarna-sava.si">matej@betonarna-sava.si</a
            ><br /><br />
            Klemen Ažman<br />
            041 444 440<br />
            <a href="mailto:klemen@betonarna-sava.si"
              >klemen@betonarna-sava.si</a
            ><br /><br />

            <strong>VODJA OBRATA</strong>
            Gašper Oblak<br />
            040 846 695<br />
            <a href="mailto:gasper@betonarna-sava.si"
              >gasper@betonarna-sava.si</a
            ><br /><br />

            <strong>TAJNIŠTVO</strong>
            Nina Aleš<br />
            040 885 865<br />
            <a href="mailto:nina.ales@betonarna-sava.si"
              >nina.ales@betonarna-sava.si</a
            >
          </div>

          <div class="contact-inner">
            <h2 class="form-title">Kontaktirajte nas</h2>

            <div class="form-wrap">
              <form
                action="/post.php"
                method="POST"
                @submit="onSubmit($event)"
                novalidate
                ref="form"
                id="contact-form"
              >
                <div class="row">
                  <div class="col-sm-6">
                    <div
                      v-bind:class="{
                        'input-wrap': true,
                        active: isActive('ime'),
                        'has-error': hasError('ime')
                      }"
                    >
                      <label for="ime">Ime in priimek</label>
                      <input
                        type="text"
                        name="ime"
                        required
                        id="ime"
                        v-model="ime"
                        @focus="onFocus('ime')"
                        @blur="onBlur('ime')"
                      />
                      <div
                        class="error"
                        v-text="errors.ime.msg"
                        v-if="errors.ime"
                      ></div>
                    </div>
                  </div>
                  <div class="col-sm-6">
                    <div
                      v-bind:class="{
                        'input-wrap': true,
                        active: isActive('telefon'),
                        'has-error': hasError('telefon')
                      }"
                    >
                      <label for="telefon">Telefonska številka</label>
                      <input
                        type="text"
                        name="telefon"
                        required
                        id="telefon"
                        v-model="telefon"
                        @focus="onFocus('telefon')"
                        @blur="onBlur('telefon')"
                      />
                      <div
                        class="error"
                        v-text="errors.telefon.msg"
                        v-if="errors.telefon"
                      ></div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-6">
                    <div
                      v-bind:class="{
                        'input-wrap': true,
                        active: isActive('email'),
                        'has-error': hasError('email')
                      }"
                    >
                      <label for="email">E-pošta</label>
                      <input
                        type="text"
                        name="email"
                        required
                        id="email"
                        v-model="email"
                        @focus="onFocus('email')"
                        @blur="onBlur('email')"
                      />
                      <div
                        class="error"
                        v-text="errors.email.msg"
                        v-if="errors.email"
                      ></div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-12">
                    <div
                      v-bind:class="{
                        'input-wrap': true,
                        textarea: true,
                        active: isActive('sporocilo'),
                        'has-error': hasError('sporocilo')
                      }"
                    >
                      <label for="sporocilo"
                        >Napiši sporočilo / vprašanje ...</label
                      >
                      <div class="fakeBg"></div>
                      <textarea
                        name="sporocilo"
                        required
                        id="sporocilo"
                        v-model="sporocilo"
                        @focus="onFocus('sporocilo')"
                        @blur="onBlur('sporocilo')"
                      ></textarea>
                      <div
                        class="error"
                        v-text="errors.sporocilo.msg"
                        v-if="errors.sporocilo"
                      ></div>
                    </div>
                  </div>
                </div>

                <p class="success text-green" v-if="sent">
                  Sporočilo uspešno poslano! <br />Kontaktirali vas bomo v
                  najkrajšem možnem času.
                </p>

                <button type="submit" :disabled="sending">Pošlji</button>
              </form>
            </div>
          </div>
        </div>
        <div class="col-md-1">
          <div class="line"></div>
        </div>
        <div class="col-md-3">
          <div class="extra-info hidden-sm">
            <strong>PROKURIST</strong>
            Klemen Ažman<br />
            041 444 440<br />
            <a href="mailto:klemen@betonarna-sava.si"
              >klemen@betonarna-sava.si</a
            ><br /><br />

            <strong>DIREKTOR</strong>
            Matej Oblak<br />
            041 633 775<br />
            <a href="mailto:matej@betonarna-sava.si">matej@betonarna-sava.si</a
            ><br /><br />

            <strong>VODJA OBRATA</strong>
            Gašper Oblak<br />
            040 846 695<br />
            <a href="mailto:gasper@betonarna-sava.si"
              >gasper@betonarna-sava.si</a
            ><br /><br />

            <strong>TAJNIŠTVO</strong>
            Nina Aleš<br />
            040 885 865<br />
            <a href="mailto:nina.ales@betonarna-sava.si"
              >nina.ales@betonarna-sava.si</a
            >
          </div>
        </div>
      </div>
    </div>

    <div id="gmaps">
      <iframe
        src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d10996.88005046616!2d14.0233201!3d46.4443375!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0xaa46663251e8f728!2sBetonarna+Sava%2C+proizvodnja+betona%2C+Frakcij+in+predelava+gradbenih+odpadkov%2C+d.o.o.!5e0!3m2!1sen!2ssi!4v1530552057795"
        width="100%"
        height="100%"
        frameborder="0"
        style="border:0"
        allowfullscreen
      ></iframe>
    </div>
  </section>
</template>

<script>
export default {
  data: function() {
    return {
      sporocilo: "",
      email: "",
      telefon: "",
      ime: "",
      active: [],
      errorText: "",
      errors: {},
      sent: false,
      sending: false
    };
  },
  methods: {
    onFocus(field) {
      if (this.active.indexOf(field) == -1) this.active.push(field);
    },
    onBlur(field) {
      if (this[field] == "") this.active.splice(this.active.indexOf(field), 1);
      else if (field == "email") {
        if (this.checkEmail(this.email)) this.errors = {};
      } else {
        this.errors = {};
      }
    },
    isActive(field) {
      return this.active.indexOf(field) > -1;
    },
    forceFocus(field) {
      document.getElementById(field).focus();
    },
    onSubmit(e) {
      e.preventDefault();
      var errors = false;
      this.errors = {};
      var fieldsToCheck = ["ime", "telefon", "email", "sporocilo"];
      for (var i = 0; i < fieldsToCheck.length; i++) {
        var field = fieldsToCheck[i];

        if (this[field] == "") {
          errors = true;
          this.errors[field] = {
            type: "empty",
            msg: "To polje je obvezno"
          };
          this.forceFocus(field);
          break;
        }

        if (field == "email") {
          if (!this.checkEmail(this.email)) {
            errors = true;
            this.errors["email"] = {
              type: "invalid",
              msg: "Vnesite veljaven e-poštni naslov"
            };
            this.forceFocus(field);
            break;
          }
        }
      }

      if (errors) return false;
      else this.post();
    },
    hasError(field) {
      return this.errors[field];
    },
    checkEmail(email) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },
    post() {
      if (this.sending) return false;

      this.sending = true;

      var xhr = new XMLHttpRequest();
      xhr.open("POST", "/post.php", true);

      xhr.setRequestHeader("Content-type", "application/x-www-form-urlencoded");

      xhr.onreadystatechange = () => {
        if (xhr.readyState == XMLHttpRequest.DONE && xhr.status == 200) {
          if (xhr.responseText == "error") {
            alert("Sporočilo ni bilo poslano! Prosimo poskusite ponovno.");
          } else {
            this.sent = true;
            this.ime = "";
            this.telefon = "";
            this.email = "";
            this.sporocilo = "";
          }
          this.sending = false;
        }
      };

      xhr.send(
        `ime=${this.ime}&telefon=${this.telefon}&email=${this.email}&sporocilo=${this.sporocilo}`
      );
    }
  }
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/Contact.vue